@if (!breakpointService.isMobile()) {
    <div class="user-trips-header">
        <img class="user-trips-header__img" [src]="bannerBgUrl | safeUrl" alt="banner img">
        <button class="user-trips-header__back-to-planner" [routerLink]="[ERoutes.SLASH, ERoutes.TRIP_PLANNER]">
            <p>{{ 'BUTTONS.BACK_TO_PLANNER' | translate }}</p>
        </button>
        @if (userProfile) {
            <h2 class="user-trips-header__text">
                {{ 'SAVED_TRIPS.YOUR_SAVED_TRIPS' | translate: {name: userProfile?.name | getName} }}
            </h2>
        }
    </div>
}

<div #savedTripsContent class="content-page">
    <div class="content-page__header">
        @if (breakpointService.isMobile() && userProfile) {
            <h2 class="content-page__welcome">
                {{ 'SAVED_TRIPS.YOUR_SAVED_TRIPS' | translate: {name: userProfile.name | getName} }}
            </h2>
        }
        <p class="content-page__title">
            {{ 'SAVED_TRIPS.TITLE' | translate }}
        </p>
    </div>

    @if (!isFetching) {
        @if (trips && trips.length) {
            <ul class="trips-list" role="list">
                @for (trip of trips | slice: 0 : visibleCount; track trip.visible_id) {
                    <li class="trips-list__item" role="listitem">
                        <app-short-trip-info
                                [trip]="trip"
                                [favourites]="favourites"
                                (shareTrip)="openSharedDialog(trip)"
                                (remove)="removeTripHandler(trip)"
                        ></app-short-trip-info>
                    </li>
                }
            </ul>
        }
    } @else {
        <ul class="trips-list" role="list">
            @for (trip of [1, 2, 3, 4]; track trip) {
                <li class="trips-list__item" role="listitem">
                    <app-short-trip-info [isFetching]="true"></app-short-trip-info>
                </li>
            }
        </ul>
    }
</div>

@if (breakpointService.isMobile()) {
    <app-start-planing-mobile></app-start-planing-mobile>
}
